import { useMemo } from "react";
import { Currency } from "@/types/currency";
import { addCurrency } from "@/utils/numbers";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cashier02Icon, ShoppingBasketCheckIn03Icon, UserGroupIcon } from "@hugeicons/core-free-icons";
import { Stack, Grid2 as Grid, Card, CardContent, Typography, Avatar, Skeleton } from "@mui/material"
import { blue, green, orange } from "@mui/material/colors";

interface Props {
    isLoading: boolean;
    totalOrders: number;
    totalClients: number;
    totalProfits: number;
}

const OrderSummary = ({ isLoading, totalOrders, totalClients, totalProfits }: Props) => {
    const orderSummaryStats = useMemo(() => {
        return [
            {
                title: 'Pedidos',
                value: totalOrders,
                icon: ShoppingBasketCheckIn03Icon,
                color: blue[500]
            },
            {
                title: 'Clientes',
                value: totalClients,
                icon: UserGroupIcon,
                color: orange[500]
            },
            {
                title: 'Ganancias',
                value: addCurrency(totalProfits, Currency.NIO, 0),
                icon: Cashier02Icon,
                color: green[500]
            }
        ]
    }, [totalOrders, totalClients, totalProfits]);

    if (isLoading) {
        return (
            <Grid container direction={"row"} spacing={3}>
                {orderSummaryStats.map((s) => (
                    <Grid key={s.title} size={{ xs: 12, lg: 4 }}>
                        <Skeleton variant="rounded" height={100} />
                    </Grid>
                ))}
            </Grid>
        )
    }

    return (
        <Grid
            container
            direction={"row"}
            spacing={{
                xs: 2,
                lg: 3
            }}
        >
            {orderSummaryStats.map((s) => (
                <Grid key={s.title} size={{ xs: 12, lg: 4 }}>
                    <Card>
                        <CardContent sx={{ padding: 3 }}>
                            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                                <Stack>
                                    <Typography variant="body1" lineHeight={1.125} component="span" fontSize="2.5rem" fontWeight={400} color="primary.main">{s.value}</Typography>
                                    <Typography variant="overline" lineHeight={1.125} color="textSecondary">{s.title}</Typography>
                                </Stack>
                                <Avatar sx={{ backgroundColor: s.color, padding: 1.5 }}>
                                    <HugeiconsIcon icon={s.icon} size={32} color="white" />
                                </Avatar>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}

export default OrderSummary;
